import { styled } from "@twilio-paste/core/styling-library";

export const LogoContainer = styled("img")`
    background-size: cover;
    background-position: center;
    width: auto;
    margin-left: 5px
`;